import { slideIn, slideOut, hide } from '../animations';
import { setForm } from './forms';

let initialIndex = 0;

export default function becomeSteps(presentation) {
  const currentInitialIndex = initialIndex;
  const { elements, presentations } = presentation;

  const {
    becomeType,
    logoLetters,
    logoLettersBoxes,
    becomeSpacer,
    introductionButton,
    becomeHeadingMoving,
    becomeBelowHeading,
    becomeButton,
    becomeContentCenter,
    logoImageFull,
    logoATriangle,
    logoWTriangle,
  } = elements;

  introductionButton.forEach((el, index) => {
    el.addEventListener('click', () => {
      if (index === 0) {
        presentation.next();
      } else {
        initialIndex = index;
        presentations.reset();
        initialIndex = 0;
        presentations.presentation.next();
      }
    });
  });

  becomeButton.forEach((el, index) => {
    el.addEventListener('click', () => {
      const isSurvey = index % 2 === 0;
      const typeIndex = Math.floor(index / 2);
      setForm((isSurvey ? 0 : 3) + typeIndex);
      presentations.fade('form');
    });
  });

  const initialEl = becomeType[initialIndex];
  const types = becomeType.map((el, index) => [index, el]);
  const typesExceptInitial = types.filter(([index]) => index !== initialIndex);
  const typesWithInitial = types.slice(initialIndex);
  const typesWithoutInitial = types.slice(initialIndex + 1);

  const {
    top: firstCenterBoxTop,
  } = becomeContentCenter[0].getBoundingClientRect();
  const {
    top: secondCenterBoxTop,
  } = becomeContentCenter[1].getBoundingClientRect();

  if (firstCenterBoxTop !== 0 && secondCenterBoxTop === 0) {
    becomeContentCenter.slice(1).forEach(el => {
      // eslint-disable-next-line no-param-reassign
      el.style.paddingTop = `${firstCenterBoxTop}px`;
    });
  }

  initialEl.classList.add('is-initial');

  function enter(isMobile) {
    return function enterInner({ timeline, label }) {
      slideIn(initialEl)({ timeline, label });

      // Reset when reversed animation before finished
      timeline.call(
        () => {
          if (
            // eslint-disable-next-line no-underscore-dangle
            !timeline._forcingPlayhead &&
            timeline.reversed() &&
            currentInitialIndex !== 0
          ) {
            presentations.reset();
          }
        },
        null,
        null,
        label,
      );

      timeline.set(logoImageFull, { opacity: 1 }, `${label}+=1`);

      typesWithInitial.forEach(([index]) => {
        const isInitial = index === initialIndex;
        const letter = logoLetters[index];
        const letterBox = logoLettersBoxes[index];
        const spacerBox = becomeSpacer[index].getBoundingClientRect();
        const spacerParentBox = becomeSpacer[
          index
        ].parentElement.getBoundingClientRect();
        let targetTransform;
        let clipPath;

        if (isMobile) {
          const isSecond = index === 1;
          const letterBoxWidth = letterBox.width + (isSecond ? 100 : 0);
          const widthScale = window.innerWidth / letterBoxWidth;
          const scaledHeight = letterBox.height * widthScale;
          let y = window.innerHeight - Math.min(scaledHeight, spacerBox.height);
          if (index === 0) {
            const centeredY = window.innerHeight - scaledHeight / 2;
            y = Math.max(y, centeredY);
          }
          const height = (window.innerHeight - y) / widthScale;
          clipPath = `polygon(0 0, 100% 0, 100% ${height}px, 0 ${height}px)`;
          targetTransform = { x: 0, y, scale: widthScale };
        } else {
          const heightScale = window.innerHeight / letterBox.height;
          const scaledWidth = letterBox.width * heightScale;
          const sideOutsideContainer =
            (window.innerWidth - spacerParentBox.width) / 2;
          let maxX = -scaledWidth + spacerBox.width + sideOutsideContainer / 2;
          if (index > 0) {
            maxX += 100;
          }

          let centeredX;
          if (index !== 2) {
            centeredX = -scaledWidth / 2;
          } else {
            const scaledPreviousWidth =
              logoLettersBoxes[index - 1].width * heightScale;
            const firstTriangleScaledWidth = scaledWidth - scaledPreviousWidth;
            centeredX = -firstTriangleScaledWidth - scaledPreviousWidth / 2;
          }

          targetTransform = {
            y: 0,
            x: Math.min(maxX, centeredX),
            scale: heightScale,
          };
        }

        if (clipPath) {
          timeline.set(
            letter,
            { clipPath, WebkitClipPath: clipPath },
            `${label}+=0.999`,
          );
        }

        if (isInitial) {
          timeline
            .set(letter, { zIndex: 20 }, label)
            .to(
              letter,
              1,
              {
                ...targetTransform,
                onComplete: () => {
                  // eslint-disable-next-line no-underscore-dangle
                  if (!timeline._forcingPlayhead && currentInitialIndex !== 0) {
                    presentations.reset();
                  }
                },
              },
              label,
            )
            .set(letter, { zIndex: '' }, `${label}+=0.999`);
        } else {
          timeline.set(
            letter,
            isMobile
              ? {
                  ...targetTransform,
                  y: targetTransform.y + window.innerHeight,
                }
              : { ...targetTransform, y: window.innerHeight },
            `${label}+=1`,
          );
        }
      });

      typesExceptInitial.forEach(([index]) => {
        timeline.to(
          logoLetters[index],
          1,
          { y: `-=${window.innerHeight}` },
          label,
        );
      });

      const aBorder = { x: 10 };
      const wBorder = { x: 10 };
      if (initialIndex === 1) {
        timeline.to(logoATriangle, 1, aBorder, label);
      } else {
        timeline.set(logoATriangle, aBorder, `${label}+=1`);
      }
      if (!isMobile) {
        if (initialIndex === 2) {
          timeline.to(logoWTriangle, 1, wBorder, label);
        } else {
          timeline.set(logoWTriangle, wBorder, `${label}+=1`);
        }
      }
    };
  }

  presentation.addStep({
    id: `become${initialIndex}`,
    default: {
      enter: enter(true),
      leave({ timeline, label }) {
        slideOut(initialEl)({ timeline, label });
        const element = logoLetters[initialIndex];
        timeline
          .to(element, 1, { y: `-=${window.innerHeight}` }, label)
          .set(element, { autoAlpha: 0 }, `${label}+=1`);
      },
    },
    large: {
      enter: enter(false),
      leave(props) {
        hide([
          becomeHeadingMoving[initialIndex],
          becomeBelowHeading[initialIndex],
        ])(props);
        slideOut(logoLetters[initialIndex])(props);
      },
    },
  });

  typesWithoutInitial.forEach(([index, el]) => {
    presentation.addStep({
      id: `become${index}`,
      default: {
        enter({ timeline, label }) {
          slideIn(el)({ timeline, label });
          timeline.to(
            logoLetters[index],
            1,
            { y: `-=${window.innerHeight}` },
            label,
          );
        },
        leave({ timeline, label }) {
          slideOut(el)({ timeline, label });
          const element = logoLetters[index];
          timeline
            .to(element, 1, { y: `-=${window.innerHeight}` }, label)
            .set(element, { autoAlpha: 0 }, `${label}+=1`);
        },
      },
      large: {
        enter({ timeline, label }) {
          slideIn(el)({ timeline, label });
          timeline.to(logoLetters[index], 1, { y: 0 }, label);
        },
        leave(props) {
          const { timeline, label } = props;
          slideOut(logoLetters[index])(props);

          if (index === types.length - 1) {
            slideOut([becomeType[initialIndex], becomeType[index]])(props);
          } else {
            timeline.set(becomeType[index], { autoAlpha: 0 }, `${label}+=1`);
            hide([becomeHeadingMoving[index], becomeBelowHeading[index]])(
              props,
            );
          }
        },
      },
    });
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/become.js